module.exports = __webpack_public_path__ + "img/07_1.77f1ea21.png";